import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 24rem;
  max-width: 100%;
`
